( function( app ) {
  const COMPONENT = {

    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.mpf__start' ).on( 'click', ( event ) => {
        $( '.mpf__intro-section, .mpf__form-section' ).fadeToggle( );
      } );

      let isFirstPage = true;

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if ( currentPage > 1 && isFirstPage ) {
          const initialBack = $( '.mpf-initial-back' );
          if ( initialBack.length ) {
            initialBack.addClass( 'is-inactive' );
          }
          isFirstPage = false;
        }

        if ( currentPage < 2 && !isFirstPage ) {
          const initialBack = $( '.mpf-initial-back' );
          if ( initialBack.length ) {
            initialBack.removeClass( 'is-inactive' );
          }
          isFirstPage = true;
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'mpf', COMPONENT );
} )( app );
